import styled from "styled-components";
import {device} from "../../../../../utils/device";

// Styled component named StyledButton
const TypeTitle = styled.div`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  text-align: center;
  && p {
    color: black;
    margin: 0;
  }
`;

export default TypeTitle;
